import {Injectable} from '@angular/core';
import {Alert, AlertStatus} from 'app/core/interfaces/alert.interface';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {Observable} from 'rxjs';
import {AuthService} from '../auth.service';
import {LocalAlertsService} from './local-alerts.service';

@Injectable({
    providedIn: 'root',
})
export class AlertsService {
    public allAlerts$: Observable<Alert[]>;

    get currentUser() {
        return this.auth.getCurrentUserLastValue();
    }

    constructor(
        public auth: AuthService,
        private localStorage: LocalStorageService,
        private localAlerts: LocalAlertsService
    ) {
        let alerts$ = this.localAlerts.alerts$;

        if (this.currentUser) {
            const serverAlerts = this.currentUser?.currentNotifications
                .filter(al => !this.localStorage.getItem('ServerAlert_' + al.id))
                .map(al => ({
                    id: al.id,
                    status: al.status as AlertStatus, // TODO typecast
                    body: al.body,
                    global: al.global,
                    onClose: () => {
                        this.localStorage.setItem('ServerAlert_' + al.id, '1');
                    },
                }));
            const currentAlerts = alerts$.getValue();
            alerts$.next([...currentAlerts, ...serverAlerts]);
        }

        this.allAlerts$ = alerts$;
    }

    dismiss(alert: Alert) {
        if (typeof alert.onClose === 'function') {
            alert.onClose();
        }

        if (this.localAlerts.dismiss(alert)) {
            return true;
        }

        // TODO send mutation
        console.log(`dismiss alert ${alert}`);
    }
}
